import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, EMPTY, Observable } from 'rxjs';
import { endpoints } from '../endpoints';
import { LabOrder } from './model/labOrder';
import { MessagingService } from '../../common/components/general-message/messaging.service';
import { LabOrderValidationError } from './model/labOrderValidationError';
import { LabOrderReport } from './model/labOrderReport';

@Injectable({
  providedIn: 'root',
})
export class LabOrderRepository {
  constructor(private readonly http: HttpClient, private readonly messagingService: MessagingService) {}

  public getLabOrder(labOrderNumber: string): Observable<LabOrder> {
    return this.http.get<LabOrder>(endpoints.labOrderEndpoint + '/' + labOrderNumber);
  }

  public saveLabOrderNew(labOrder: LabOrder): Observable<LabOrder> {
    return this.http.post(endpoints.labOrderEndpoint, labOrder).pipe(catchError(err => this.handleError(err)));
  }

  public saveLabOrderExisting(labOrder: LabOrder): Observable<LabOrder> {
    return this.http.put(endpoints.labOrderEndpoint + '/' + labOrder.labOrderNumber, labOrder).pipe(catchError(err => this.handleError(err)));
  }

  public getDSR(inputLabOrderNumber: string): Observable<LabOrderReport> {
    return this.http.get<LabOrderReport>(endpoints.labOrderEndpoint + '/reports/' + inputLabOrderNumber).pipe(catchError(err => this.handleLabValidationError(err)));
  }

  private handleError(err: { error: LabOrderValidationError[] }): Observable<LabOrder> {
    if (err?.error) {
      this.messagingService.pushError('Errors', err.error);
    } else {
      this.messagingService.pushError();
    }
    return EMPTY;
  }

  private handleLabValidationError(err: { error: LabOrderValidationError }) {
    if (err?.error && err?.error.message) {
      this.messagingService.pushError('Error', [err.error]);
    } else {
      this.messagingService.pushError();
    }
    return EMPTY;
  }
}
